<template>
	<div class="g-searchspring__container" v-if="searchData.results">
		<cart-toast :results="searchData.results" />
		<div class="g-searchspring__header">
			<banner :merchandising="searchData.merchandising" type="header" />
			<banner :merchandising="searchData.merchandising" type="banner" />
		</div>
		<div class="g-searchspring__content g-layout g-layout--justify-center">
			<div id="js-searchspring-facets" class="g-searchspring__div g-layout__item u-width-12 u-width-3--l" v-if="searchData.results.length">
				<facets :facets="searchData.facets" :filterSummary="searchData.filterSummary" :pagination="searchData.pagination" />
				<banner :merchandising="searchData.merchandising" type="left" />
			</div>
			<div class="g-searchspring__results g-layout__item u-width-12 u-width-9--l" v-if="searchData.results.length">
				<search-results
					:facets="searchData.facets"
					:filterSummary="searchData.filterSummary"
					:merchandising="searchData.merchandising"
					:pagination="searchData.pagination"
					:results="searchData.results"
					:sorting="searchData.sorting" />
				<banner :merchandising="searchData.merchandising" type="footer" />
			</div>

			<div id="js-ntfd" class="g-searchspring__results g-ntfd-wrapper g-layout__item u-width-12" v-else>
				<div class="g-ntfd-content">
					<div class="g-ntfd-search">
						<div class="g-ntfd-search__inner">
							<div class="g-ntfd-search-header" v-if="Screen = 'CTGY'">
								<h2 class="g-ntfd-search-header__title">Sorry, no matches were found.</h2>
								<p class="g-ntfd-search-header__subtitle">Try a new search or explore one of our suggestions.</p>
							</div>
							<div class="g-ntfd-search-header" v-else>
								<h1 class="g-ntfd-search-header__title">Sorry, page not found.</h1>
								<p class="g-ntfd-search-header__subtitle">Try using our search or explore one of our suggestions.</p>
							</div>
							<form class="g-ntfd-search-form" method="get" :action="SearchUrl">
								<fieldset>
									<legend class="u-hide-visually">Product Search</legend>
									<div class="g-form-list">
										<div class="g-form-list__item g-form-list__item--full g-control-group u-flex">
											<input class="g-form-input g-control-group__field u-bg-transparent u-border-none g-ntfd-search-form__input" type="search" name="Search" value="" placeholder="Try Searching Again" autocomplete="off" aria-label="Try Searching Again" required v-if="Screen = 'CTGY'">
											<input class="g-form-input g-control-group__field u-bg-transparent u-border-none g-ntfd-search-form__input" type="search" name="Search" value="" placeholder="Try Searching" autocomplete="off" aria-label="Try Searching" required v-else>
											<button class="g-button g-control-group__button u-bg-transparent u-icon-search u-border-none g-ntfd-search-form__button" type="submit">
												<span class="u-hide-visually">Search</span>
											</button>
										</div>
									</div>
								</fieldset>
							</form>
							<div class="g-ntfd-search-tips">
								<p class="g-ntfd-search-tips__title">Search Tips:</p>
								<ul class="g-ntfd-search-tips__list">
									<li class="g-ntfd-search-tips__list-item">Please double check your spelling.</li>
									<li class="g-ntfd-search-tips__list-item">Use more generic search terms (e.g. Football Jersey, baseball hat).</li>
									<li class="g-ntfd-search-tips__list-item">Your product search may have been discontinued, removed, or is not yet on our site.</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="g-ntfd-carousel">
						<x-ss-recommendations title="Items You May Like" type="MAY_LIKE" tags="no-results" list="Items You May Like" limits="20" :carousel-options="JSON.stringify(ntfdCarouselOptions)"></x-ss-recommendations>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import debounce from '@mvps-genesis/debounce';
import '../../../../searchspring-recommendations';
import '../../../../searchspring-trending-searches';
import Search from '../../Search';
import {CATEGORY_FACETS, DEPARTMENT_FACETS} from '../../data/facets-store';
import {insertFacetOptionOverflows, insertInlineBanners, removeCategoryFacets, removeDepartmentFacets, sortDepartments, updateResults} from '../../middleware/middleware';
import {processMiddleware} from '../../middleware/process-middleware';
import Banner from './Banner';
import CartToast from './CartToast';
import Facets from './Facets';
import SearchResults from './SearchResults';
import SortBy from './SortBy';

	// define parameter removelist for routing
	const paramRemoveList = [/siteId=.*/, /resultsFormat=.*/, /bgfilter\..*=.*/, /q=.*/, /page=1$/, /tag=.*/, /BranchKey=.*/, /domain=.*/, /pageLoadId=.*/, /sessionId=.*/, /userId=.*/];

	// create filtering function
	function requestParamsReducer(params, param) {
		return {
			...params,
			...(!paramRemoveList.some((regex) => regex.test(`${param}=${this[param]}`))) ? {[param]: this[param]} : {}
		};
	}

	// update response cacher
	let updatedResults = {};
	const pushedImpressions = [];
	let impressionArray = [];

	export default {
		data() {
			return {
				isLoading: true,
				loadingClassname: 'g-product-listing-loader--loading',
				loadingContainerElement: document.getElementById('js-product-listing-loader-container'),
				loadingElement: document.getElementById('js-product-listing-loader'),
				searchData: {},
				query: null,
				windowWidth: window.innerWidth,
				Screen: mivaJS.Screen,
				SearchUrl: mivaJS.Search_Url,
				ntfdCarouselOptions: {
					'perPage': 5,
					'pagination': false,
					'breakpoints': {
						'1280': {
							'perPage': 4
						},
						'768': {
							'padding': {
								'left': 0,
								'right': '15%'
							},
							'perPage': 3
						},
						'640': {
							'gap': '1.25rem',
							'padding': {
								'left': 0,
								'right': '20%'
							},
							'perPage': 2
						}
					}
				}
			}
		},
		created() {

			// popstate
			window.addEventListener('popstate', debounce(500, () => {

				Search.client
					.reset()
					.setState(this.$route.query)
					.search();

			}));

			const {
				siteId,
				BranchKey,
				...filteredQuery
			} = this.$route.query;

			// set state from URL
			Search.client.setState(filteredQuery);

			// set query
			this.query = Search.client.states.search.params.q;

			// bind event listener
			Search.client.on('search', (e) => this.onSearch(e.detail));

			// run default search
			Search.client.search().catch(e => {
				// Handle a 400 - Bad Response from SS
				if(e.response.status === 400) {
					this.onEmpty();
				}
			});

		},
		methods: {
			onEmpty() {
				document.title = 'Rally House | No results';
				return {};
			},
			async onSearch(request = {}) {
				if (!Search.isLoaded) {
					Search.isLoaded = true;
				}

				if (request.response.data?.merchandising?.redirect) {
					const redirectString = request.response.data.merchandising.redirect;

					// handle full and relative URLs
					if (redirectString.startsWith('https://') || redirectString.startsWith('http://')) {
						window.location.replace(redirectString);
					} else {
						window.location.replace(window.location.origin + redirectString);
					}
					return;
				}

				// process middleware
				this.searchData = await processMiddleware(
					request.response.data,
					[
						updateResults(),
						insertInlineBanners(),
						insertFacetOptionOverflows(),
						sortDepartments(),
						removeDepartmentFacets(DEPARTMENT_FACETS),
						removeCategoryFacets(CATEGORY_FACETS)
					]
				);

				this.query = Search.client.states.search.params.q;
				this.merchandisingContent = this.searchData?.merchandising?.content ? this.searchData.merchandising.content : {};

				// filter params by removelist
				const params = Object.keys(request.requestParams).reduce(requestParamsReducer.bind(request.requestParams), {});

				// update router
				this.$router.push({query: params}).catch((err) => {
					return {};
				});

				this.$forceUpdate();

				if (this.isLoading) {
					this.handleLoading();
				}
			},
			handleLoading() {
				if (!this.isLoading || !this.loadingContainerElement || !this.loadingElement) {
					return;
				}

				this.loadingContainerElement.classList.remove(this.loadingClassname);

				this.isLoading = false;

				const timeoutTime = this.loadingContainerElement.classList.contains('g-product-listing-loader--searchspring') ? 50 : 350;
				setTimeout(() => {
					this.loadingElement.remove();
				}, timeoutTime)
			}
		},
		components: {
			'search-results': SearchResults,
			'facets': Facets,
			'banner': Banner,
			'sort-by': SortBy,
			'cart-toast': CartToast
		}
	}

</script>
